import { lazy, Suspense } from 'react';
import Box from '@mui/material/Box';
import { Hero } from '@/components/Hero';
import { Differentiators } from '@/components/Differentiators';
import { Consolidation } from '@/components/Consolidation';
import { AgenticAI } from '@/components/AgenticAI';
import { Features } from '@/components/Features';
import { TrustBand } from '@/components/TrustBand';
import { Assurance } from '@/components/Assurance';
import { FinalCta } from '@/components/FinalCta';
import { useSeo } from '@/seo/useSeo';

// Code-split: Progress pulls in @mui/x-charts' Gauge (and its d3 dependency chain), by far the
// heaviest import in this bundle, to render one below-the-fold decorative gauge. Lazy-loading it
// keeps that weight out of the initial JS payload so it can't delay LCP/TBT on the sections that
// actually matter for a first-time visitor or a crawler's render pass.
const Progress = lazy(() => import('@/components/Progress').then((m) => ({ default: m.Progress })));

export function Home(): JSX.Element {
  useSeo({
    title: 'The Agentic PSA + RMM Platform Built for MSPs',
    description:
      'Nexus is the agentic PSA + RMM platform for MSPs — autonomous ticket resolution, endpoint management, security, and compliance in one platform, one bill.',
    path: '/',
  });
  return (
    <Box>
      <Hero />
      <Differentiators />
      <Consolidation />
      <AgenticAI />
      <Features />
      <TrustBand />
      <Assurance />
      <Suspense fallback={<Box className="py-16 md:py-24" />}>
        <Progress />
      </Suspense>
      <FinalCta />
    </Box>
  );
}
